/**
 * Iter130 — CASE LOGS hub.
 *
 * Consolidates the previously-separate top-level tiles:
 *   Evidence
 *   Field Logs (case-logs)
 *   Reports
 *
 * Rendered as a single tabbed page under /case-logs so the Modules
 * Menu Box only exposes one entry point.
 */
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ClipboardList, Camera, FileText } from 'lucide-react';
import Evidence from './Evidence';
import CaseLogs from './CaseLogs';
import Reports from './Reports';

export default function CaseLogsHub() {
  const [tab, setTab] = useState('field-logs');
  return (
    <div className="space-y-4" data-testid="case-logs-hub-page">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-amber-500/20 border border-amber-500/40 flex items-center justify-center">
          <ClipboardList className="w-6 h-6 text-amber-300" />
        </div>
        <div>
          <div className="text-xs text-amber-300 uppercase tracking-wider font-mono">NexusTrac · Case Logs</div>
          <h1 className="text-2xl font-bold text-white">Case Logs</h1>
          <p className="text-slate-400 text-sm">Evidence, field logs, and investigation reports — one workspace.</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="bg-[#131A2A] border border-[#334155]">
          <TabsTrigger value="field-logs" data-testid="tab-case-logs-field">
            <ClipboardList className="w-4 h-4 mr-1" /> Field Logs
          </TabsTrigger>
          <TabsTrigger value="evidence" data-testid="tab-case-logs-evidence">
            <Camera className="w-4 h-4 mr-1" /> Evidence
          </TabsTrigger>
          <TabsTrigger value="reports" data-testid="tab-case-logs-reports">
            <FileText className="w-4 h-4 mr-1" /> Reports
          </TabsTrigger>
        </TabsList>
        <TabsContent value="field-logs" className="mt-4"><CaseLogs /></TabsContent>
        <TabsContent value="evidence" className="mt-4"><Evidence /></TabsContent>
        <TabsContent value="reports" className="mt-4"><Reports /></TabsContent>
      </Tabs>
    </div>
  );
}
